export const COLLECTIONS = [
  'General',
  'Watering guide',
  'Fertilizing guide',
  'Repotting guide',
  'Lighting guide',
  'Propagating guide',
  'Pruning guide',
]



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Articles/consts.js